import { Auth } from 'aws-amplify';
import { ProfileApi } from '@/api';
import { Profile } from '@/api/model/profile';
import { CognitoUserInterface } from '@aws-amplify/ui-components';
import i18n from '@/i18n';
import TrackingService from '@/logic/profile/TrackingService';

// @todo extract getConfiguration
async function getConfiguration() {
  const session: any = await Auth.currentSession();
  const baseOptions = {
    headers: {
      authorization: session.idToken.jwtToken,
    },
  };
  return { baseOptions };
}

async function addProfile(commit: Function, dispatch: Function) {
  const user: CognitoUserInterface = await Auth.currentAuthenticatedUser();
  let newProfile: Profile = {
    email: user.attributes.email,
    locale: user.attributes.locale,
  };
  if (user.attributes.phone) {
    newProfile.phone = user.attributes.phone;
  }

  const utmProps = TrackingService.getUtmProperties();
  if (utmProps) {
    newProfile = { ...newProfile, ...utmProps };
  }
  commit('setProfile', newProfile);
  dispatch('saveProfile', newProfile);
}

export default {
  namespaced: true,
  state: {
    profile: {} as Profile,
  },

  mutations: {
    setProfile(state: any, profile: Profile) {
      state.profile = profile;
      if (profile.locale) {
        i18n.locale = profile.locale;
      }
    },

    deleteProfile(state: any) {
      state.profile = {};
    },
  },

  actions: {
    async getProfile({
      commit,
      dispatch,
    }: {
      commit: Function;
      dispatch: Function;
    }) {
      const configuration = await getConfiguration();
      const api = new ProfileApi(configuration, '');

      let profile = {};
      try {
        const response = await api.profileGet();
        const jsonResponse = JSON.parse(JSON.stringify(response));
        profile = jsonResponse.data;
      } catch (e) {
        // Could not retrieve profile, so keep it empty
      }

      if (Object.keys(profile).length === 0) {
        await addProfile(commit, dispatch);
      } else {
        commit('setProfile', profile);
      }
    },

    async saveProfile({ commit }: { commit: Function }, profile: Profile) {
      const configuration = await getConfiguration();
      const api = new ProfileApi(configuration, '');
      const { data } = await api.profilePut(profile);
      commit('setProfile', data);
    },

    async deleteProfile({ commit }: { commit: Function }, profile: Profile) {
      commit('deleteProfile', profile);
      const configuration = await getConfiguration();
      const api = new ProfileApi(configuration, '');
      // @todo implement delete
      await api.profilePut({} as Profile);
    },
  },
};
